import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

interface FundStrategiesProps extends MultiTableComponentProps {
  tableKey: string;
}

const columnLables = {
  hedge_fund_strategy_type: {
    name: 'Investment strategy code'
  },
  primary_strategy_flag: {
    name: 'Primary strategy flag'
  },
  strategy_nav_rate: {
    name: 'Investment strategy NAV percentage '
  },
  strategy_type_other_description: {
    name: 'Description for strategy type Other'
  }
};

export function FundStrategies({
  funds,
  currentDataKey,
  onChangeFund,
  tableKey,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: FundStrategiesProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data[tableKey],
    onChangeFund,
    tableKey,
    schema: schema[tableKey],
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.[tableKey]?.field_names || [],
    tableName: tableKey,
    columnLables,
    //@ts-ignore
    order: 58,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id={`reporttables-fund-strategies-${tableKey}-table`}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      stickyTopRows={isMultiFunds ? 1 : null}
      columns={columns}
      rows={rows}
    />
  );
}
